module.exports = __webpack_public_path__ + "static/media/art38.0e24a4b8.jpg";